"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchFeatureExpVariationSchema = exports.PostFeatureExpVariationSchema = exports.FeatureExpVariationsWithPaginationTypeSchema = exports.FeatureExpVariationSchema = exports.FeatureExpVariationModificationsSchema = exports.FeatureExpVariationModificationsValueSchema = exports.FeatureExpVariationEditorTypeEnumSchema = exports.FeatureExpVariationModificationsTypeEnumSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const schemas_2 = require("../flagVariation/schemas");
const schemas_3 = require("../../../helpers/schemas");
exports.FeatureExpVariationModificationsTypeEnumSchema = zod_1.z.enum(['FLAG', 'JSON']);
exports.FeatureExpVariationEditorTypeEnumSchema = zod_1.z.enum(['JSON', 'standard']);
exports.FeatureExpVariationModificationsValueSchema = zod_1.z.union([zod_1.z.array(zod_1.z.any()), zod_1.z.record(zod_1.z.any())]).optional();
exports.FeatureExpVariationModificationsSchema = zod_1.z.object({
    type: exports.FeatureExpVariationModificationsTypeEnumSchema,
    value: exports.FeatureExpVariationModificationsValueSchema,
});
exports.FeatureExpVariationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    allocation: zod_1.z.number(),
    reference: zod_1.z.boolean(),
    flagsVariation: zod_1.z.array(schemas_2.FeatureExpFlagVariationSchema).optional(),
    modifications: exports.FeatureExpVariationModificationsSchema,
    order: zod_1.z.number(),
    editor_type: exports.FeatureExpVariationEditorTypeEnumSchema,
    formatted_created_at: schemas_3.ApiDateTimeSchema,
    formatted_updated_at: schemas_3.ApiDateTimeSchema,
});
exports.FeatureExpVariationsWithPaginationTypeSchema = schemas_1.FeatureExpPaginationSchema.and(zod_1.z.object({
    items: zod_1.z.array(exports.FeatureExpVariationSchema),
}));
const FeatureExpVariationMutationPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    campaign_id: zod_1.z.string(),
    variation_group_id: zod_1.z.string(),
});
exports.PostFeatureExpVariationSchema = exports.FeatureExpVariationSchema.pick({
    name: true,
    allocation: true,
    reference: true,
    modifications: true,
    order: true,
    editor_type: true,
}).and(FeatureExpVariationMutationPropsSchema);
exports.PatchFeatureExpVariationSchema = exports.FeatureExpVariationSchema.partial({
    allocation: true,
    reference: true,
    modifications: true,
    formatted_created_at: true,
    formatted_updated_at: true,
}).and(FeatureExpVariationMutationPropsSchema);
//# sourceMappingURL=schemas.js.map